var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 35L0.5 13L11.5 17V0H33.5V17L44.5 13L22.5 35Z",
    fill: "url(#paint0_linear_832_1630)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_832_1630",
    x1: 22.5,
    y1: 0,
    x2: 22.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F9ACB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F9ACB",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualArrow);
export default __webpack_public_path__ + "static/media/manual_arrow.51da92f0d2285f4a3026d8e25e75075a.svg";
export { ForwardRef as ReactComponent };